export const positiveNumbers = /^\d*[1-9]\d*$/;
export const phoneNumber = /^(0)([0-9]{9,10})$/;
export const positiveNumbersWithZero = /(^0|(^\d*[1-9]\d*))$/;
export const numberInRangeFrom0To100 = /^(0|[1-9][0-9]?|100)$/;
export const numberInRangeFrom0To99 = /^(0?[0-9]|[0-9][0-9])$/;
